/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PurposeType } from './PurposeType';
import {
    PurposeTypeFromJSON,
    PurposeTypeFromJSONTyped,
    PurposeTypeToJSON,
    PurposeTypeToJSONTyped,
} from './PurposeType';
import type { AttendanceType } from './AttendanceType';
import {
    AttendanceTypeFromJSON,
    AttendanceTypeFromJSONTyped,
    AttendanceTypeToJSON,
    AttendanceTypeToJSONTyped,
} from './AttendanceType';

/**
 * 
 * @export
 * @interface AttendanceOverviewEntryResponse
 */
export interface AttendanceOverviewEntryResponse {
    /**
     * 
     * @type {string}
     * @memberof AttendanceOverviewEntryResponse
     */
    appointmentId: string;
    /**
     * 
     * @type {Date}
     * @memberof AttendanceOverviewEntryResponse
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof AttendanceOverviewEntryResponse
     */
    purposeKey: string;
    /**
     * 
     * @type {PurposeType}
     * @memberof AttendanceOverviewEntryResponse
     */
    purposeType: PurposeType;
    /**
     * 
     * @type {AttendanceType}
     * @memberof AttendanceOverviewEntryResponse
     */
    attendanceType: AttendanceType | null;
    /**
     * 
     * @type {string}
     * @memberof AttendanceOverviewEntryResponse
     */
    location: string | null;
    /**
     * 
     * @type {Date}
     * @memberof AttendanceOverviewEntryResponse
     */
    startTimeUtc: Date;
    /**
     * 
     * @type {Date}
     * @memberof AttendanceOverviewEntryResponse
     */
    endTimeUtc: Date;
    /**
     * 
     * @type {string}
     * @memberof AttendanceOverviewEntryResponse
     */
    details: string | null;
    /**
     * 
     * @type {string}
     * @memberof AttendanceOverviewEntryResponse
     */
    substituteCounselorUserCode: string | null;
    /**
     * 
     * @type {Date}
     * @memberof AttendanceOverviewEntryResponse
     */
    reachableFromDate: Date | null;
}



/**
 * Check if a given object implements the AttendanceOverviewEntryResponse interface.
 */
export function instanceOfAttendanceOverviewEntryResponse(value: object): value is AttendanceOverviewEntryResponse {
    if (!('appointmentId' in value) || value['appointmentId'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('purposeKey' in value) || value['purposeKey'] === undefined) return false;
    if (!('purposeType' in value) || value['purposeType'] === undefined) return false;
    if (!('attendanceType' in value) || value['attendanceType'] === undefined) return false;
    if (!('location' in value) || value['location'] === undefined) return false;
    if (!('startTimeUtc' in value) || value['startTimeUtc'] === undefined) return false;
    if (!('endTimeUtc' in value) || value['endTimeUtc'] === undefined) return false;
    if (!('details' in value) || value['details'] === undefined) return false;
    if (!('substituteCounselorUserCode' in value) || value['substituteCounselorUserCode'] === undefined) return false;
    if (!('reachableFromDate' in value) || value['reachableFromDate'] === undefined) return false;
    return true;
}

export function AttendanceOverviewEntryResponseFromJSON(json: any): AttendanceOverviewEntryResponse {
    return AttendanceOverviewEntryResponseFromJSONTyped(json, false);
}

export function AttendanceOverviewEntryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttendanceOverviewEntryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'appointmentId': json['appointmentId'],
        'date': (new Date(json['date'])),
        'purposeKey': json['purposeKey'],
        'purposeType': PurposeTypeFromJSON(json['purposeType']),
        'attendanceType': AttendanceTypeFromJSON(json['attendanceType']),
        'location': json['location'],
        'startTimeUtc': (new Date(json['startTimeUtc'])),
        'endTimeUtc': (new Date(json['endTimeUtc'])),
        'details': json['details'],
        'substituteCounselorUserCode': json['substituteCounselorUserCode'],
        'reachableFromDate': (json['reachableFromDate'] == null ? null : new Date(json['reachableFromDate'])),
    };
}

export function AttendanceOverviewEntryResponseToJSON(json: any): AttendanceOverviewEntryResponse {
    return AttendanceOverviewEntryResponseToJSONTyped(json, false);
}

export function AttendanceOverviewEntryResponseToJSONTyped(value?: AttendanceOverviewEntryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'appointmentId': value['appointmentId'],
        'date': `${value['date'].getFullYear()}-${String(value['date'].getMonth()+1).padStart(2,'0')}-${String(value['date'].getDate()).padStart(2,'0')}`,
        'purposeKey': value['purposeKey'],
        'purposeType': PurposeTypeToJSON(value['purposeType']),
        'attendanceType': AttendanceTypeToJSON(value['attendanceType']),
        'location': value['location'],
        'startTimeUtc': value['startTimeUtc'].toISOString(),
        'endTimeUtc': value['endTimeUtc'].toISOString(),
        'details': value['details'],
        'substituteCounselorUserCode': value['substituteCounselorUserCode'],
        'reachableFromDate': value['reachableFromDate'] == null ? value['reachableFromDate'] : `${value['reachableFromDate'].getFullYear()}-${String(value['reachableFromDate'].getMonth()+1).padStart(2,'0')}-${String(value['reachableFromDate'].getDate()).padStart(2,'0')}`,
    };
}

